export const ROLE_ADMIN = 'admin'

// Tenant context mode type - represents organization-level vs project-level context
export type TenantContextMode = 'ORGANIZATION_LEVEL' | 'PROJECT_LEVEL'

// Base configuration interface that all mode configs extend
export interface BaseTenantContextModeConfig {
	mode: TenantContextMode
}

export function determineTenantContextMode(isOrganizationLevel: boolean): TenantContextMode {
	return isOrganizationLevel ? 'ORGANIZATION_LEVEL' : 'PROJECT_LEVEL'
}

export function getTenantContextModeConfig<T extends BaseTenantContextModeConfig>(
	configRecord: Record<TenantContextMode, T>,
	mode: TenantContextMode,
): T {
	return configRecord[mode]
}
